import logoImage from './../assets/images/cigna-logo.png';
import FormHeader from "../components/cigna/FormHeader";
import FormFooter from "../components/cigna/FormFooter";
import {getFormFields} from "../components/cigna/fields";
import {CLIENT_NAME, CLIENT_THEME} from "../utils/constants";
import APP_ENV from "../config/appEnv";

const config = {
    clientName: CLIENT_NAME.CIGNA,
    isMultiLingual: true,

    // theme
    theme: CLIENT_THEME.CIGNA,

    // header
    logo: logoImage,
    logoHeight: 60,
    logoLink: APP_ENV.CLIENT_RETURN_URL,

    // entry form
    entryForm: {
        title: 'HealthSpring Enrollee Advisory Committee Application',
        titleBg: 'secondary',
        customHeader: {
            enabled: true,
            component: FormHeader
        },
        customFields: {
            enabled: true,
            fieldGetter: getFormFields,
        },
        showReturn: false,
        showCancel: false,
        formSuccess: {
            message: 'Your response has been submitted.'
        }
    },

    // footer
    footer: {
        customFooter: {
            enabled: true,
            component: FormFooter,
        },
        meta: {
            materialId: 'Y0036_26_4343226960_C'
        },
        copyright: `© HealthSpring 2024. All rights reserved.`,
    },
    tracking: {
        mail: "/?utm_source=mail&utm_medium=online&utm_campaign=recruit",
        mails: "/?utm_source=mails&utm_medium=online&utm_campaign=recruit&lang=esp",
        mnews: "/?utm_source=mnews&utm_medium=online&utm_campaign=recruit",
        mnewss: "/?utm_source=mnewss&utm_medium=online&utm_campaign=recruit&lang=esp",
        cs: "/?utm_source=cs&utm_medium=phone&utm_campaign=recruit",
        cms: "/?utm_source=cms&utm_medium=phone&utm_campaign=recruit",
        email: "/?utm_source=email&utm_medium=online&utm_campaign=recruit",
        emails: "/?utm_source=emails&utm_medium=online&utm_campaign=recruit&lang=esp",
        enews: "/?utm_source=enews&utm_medium=online&utm_campaign=recruit",
        enewss: "/?utm_source=enewss&utm_medium=online&utm_campaign=recruit&lang=esp",
        sms: "/?utm_source=sms&utm_medium=phone&utm_campaign=recruit",
        lp: "/?utm_source=lp&utm_medium=phone&utm_campaign=recruit",
        lps: "/?utm_source=lps&utm_medium=phone&utm_campaign=recruit&lang=esp",
        portal: "/?utm_source=portal&utm_medium=online&utm_campaign=recruit",
    }
}

export default config;
